export default "__VITE_ASSET__FREhwYxP__"